module.exports = __webpack_public_path__ + "static/media/01_A7_102.71cd0b76.png";